import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-peace': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M362.1 192C348.4 170.3 323.4 158 297.1 161.6V74C297.1 33.2 264.3 0 224 0 183.7 0 150.9 33.2 150.9 74L160 168 141.3 89.1C126.6 50.8 83.8 32.1 46.2 47.2 8.7 62.2-9.6 105 5 142.9L60.8 287.8C30.2 312.7 16.8 345.6 36 380L90.9 478C102.6 499 124.7 512 148.6 512H354.3C385 512 411.8 490.6 418.8 460.2L446.3 341.2A67.8-67.8 0 0 1 448 326L448 256C448 211 404.7 178.7 362.1 192zM400 326C400 327.5 399.8 329 399.5 330.4L372.1 449.4C370.1 458 362.8 464 354.3 464H148.6C142.1 464 136 460.4 132.8 454.6L77.9 356.6C73.4 348.4 75.3 337.9 82.4 332.1L109.1 310.3A16-16 0 0 1 113.9 292.2L49.8 125.6C37.2 93 84.4 74.8 96.5 106.4L156.3 261.7A16-16 0 0 1 171.2 272H182.9C191.7 272 198.9 264.8 198.9 256V74C198.9 39.6 249.1 39.6 249.1 74V256C249.1 264.8 256.3 272 265.1 272H272C280.8 272 288 264.8 288 256V228C288 202.9 324.6 202.8 324.6 228V256C324.6 264.8 331.7 272 340.6 272H347.4C356.3 272 363.4 264.8 363.4 256 363.4 230.9 400 230.8 400 256V326z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-peace.js
// module id = VBnm
// module chunks = 144